import React, { useEffect } from "react";
import { ThemeProvider } from "styled-components";
import { GlobalStyle } from "./styles/GlobalStyle";
import { theme } from "./styles/theme";
import Routers from "./Routers";
import axios from "axios";
import { toast } from "react-toastify";
import Toast from "./components/Modal/Toast";
import { Helmet } from "react-helmet-async";
import { isBeta } from "./AdminConfig";

function App() {
  // 배포 환경에서 console.log, console.warn 지우기
  if (process.env.NODE_ENV === "production") {
    console.log = function no_console() {};
    console.warn = function no_console() {};
  }

  useEffect(() => {
    axios.interceptors.response.use(
      (config) => {
        if (
          config?.data?.items?.length === 0 &&
          !window.location?.pathname?.includes("/users/info/") &&
          !window.location?.pathname?.includes("/party/info/")
        ) {
          toast.error("해당 검색어 정보를 찾을 수 없습니다.");
        } else {
          return config;
        }
      },
      (error) => {
        if (error?.response?.status === 403) {
          toast.error("권한이 없습니다.");
        } else if (error?.response?.status === 500) {
          toast.error("Internal server error");
        } else if (
          !error?.config?.url?.includes("netflix") &&
          error?.response?.status === 504
        ) {
          toast.error("작업을 실행할 수 없습니다.");
        } else if (error?.response?.status === 900) {
          toast.error("세션이 만료되었습니다.", {
            onClose: () => {
              setTimeout(() => {
                window.location.pathname = "/login";
              }, 2000);
            },
          });
        } else {
          return Promise.reject(error);
        }
      }
    );
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <div>
        <Helmet>
          <title>L1nk1d Admin {isBeta ? "Beta" : ""}</title>
        </Helmet>

        <GlobalStyle />

        <Routers />

        <Toast />
      </div>
    </ThemeProvider>
  );
}

export default App;
